import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import injectTapEventPlugin from 'react-tap-event-plugin';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import store from './store';
import router from './router';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: '#00A7F7'
  }
});

document.addEventListener('gesturestart', function(e) {
  e.preventDefault();
});

window.addEventListener('load', function() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('sw.js', {
      scope: './'
    }).then(function(reg) {
      console.log('Service worker has been registered for scope:' + reg.scope);
    });
  }
});

import './index.css';

class App extends Component {

  render() {

    return <MuiThemeProvider muiTheme={muiTheme}>
      <Provider store={store}>{router}</Provider>
    </MuiThemeProvider>;

  }

}

ReactDOM.render(
    <App/>,
    document.getElementById('root')
);
